import { isAgent } from "../../utils/nick-utils";
import { ChatMemberLeaveDetail } from "../ChatAction";
import { ChatState } from "../ChatState";
import { joinMessages } from "./joinMessages";
import { log } from "../../utils";

export function memberLeave(state: ChatState, detail: ChatMemberLeaveDetail): ChatState {
    const agents = { ...state.agents };
    const prevAgentInfo = state.agents[detail.user.nick];

    agents[detail.user.nick] = {
        ...prevAgentInfo,
        joined: false,
        typing: false
    };

    // count number of agents that are still joined
    const agentsJoined = Object.values(agents).filter((agent) => agent.joined);
    const isChatting = agentsJoined.length > 0;

    if (isAgent(detail.user.nick)) {
        const hasSpecialVisuals = detail.showDivider || detail.message;

        if (prevAgentInfo?.joined) {
            if (hasSpecialVisuals) {
                log(`Agent "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) is leaving with special visuals (divider or custom message). Adding leave message to chat.`);
            } else {
                log(`Agent "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) is leaving. Adding leave message to chat.`);
            }
        } else {
            log(`DEDUPLICATION: Agent "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) already left. NOT adding duplicate leave message to chat.`);
        }

        return {
            ...state,
            isChatting,
            chats: prevAgentInfo?.joined ? joinMessages(state.chats, detail) : state.chats,
            agents
        };
    } else {
        log(`Non-agent member "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) is leaving. Adding leave message to chat.`);
        return {
            ...state,
            isChatting,
            chats: joinMessages(state.chats, detail),
            agents
        };
    }
}